"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestUserEmployeeWarnings = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const userEmployeeWarningsQuery = (0, graphql_tag_1.default) `
query UserEmployeeWarnings($workspaceId: ID!, $userId: ID!) {
  workspace(id: $workspaceId) {
    employeeWarnings(users: [$userId]) {
      userId
      warnings {
        name
        data
      }
    }
  }
}`;
const requestUserEmployeeWarnings = async ({ workspaceId, userId, }) => {
    const { data, errors } = await (0, apollo_1.query)(userEmployeeWarningsQuery, {
        variables: {
            workspaceId, userId,
        },
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.workspace;
};
exports.requestUserEmployeeWarnings = requestUserEmployeeWarnings;
